import { useFormikContext } from "formik";
import { NotificationFormModel } from "../../../types/Notification";
import ReactQuill from "react-quill";
import { ErrorText } from "../../../@ui/ErrorText";
import styled from "styled-components";
import { Form } from "react-bootstrap";
import TimeInput from "../../../form/time/timeInput";

const TimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  width: 100%;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const NotificationForm = () => {
  const { values, errors, touched, handleBlur, handleChange, setFieldValue } =
    useFormikContext<NotificationFormModel>();

  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline"],
        ["link", "image"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["clean"],
      ],
    },
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "link",
    "image",
    "list",
    "bullet",
  ];

  return (
    <>
      <Form.Label className="mt-2">Notification Date</Form.Label>
      <TimeContainer>
        <div className="d-flex flex-column w-50 gap-1">
          <Form.Control
            type="date"
            name="notificationDate"
            value={values.notificationDate || ""}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {errors.notificationDate && touched.notificationDate && (
            <ErrorText className="text-danger px-1">
              {errors.notificationDate}
            </ErrorText>
          )}
        </div>

        <div className="d-flex flex-column w-50 gap-1">
          <TimeInput
            name="notificationTime"
            value={values.notificationTime || ""}
            hasError={!!errors.notificationTime}
            onChange={(value: string) =>
              setFieldValue("notificationTime", value)
            }
            onBlur={handleBlur}
          />
          {errors.notificationTime && touched.notificationTime && (
            <ErrorText className="text-danger px-1">
              {errors.notificationTime}
            </ErrorText>
          )}
        </div>
      </TimeContainer>
      <Form.Label className="mt-2">Message</Form.Label>
      <ReactQuill
        formats={formats}
        modules={modules}
        value={values.message}
        onBlur={() => handleBlur({ target: { name: "message" } })}
        onChange={(content) => {
          setFieldValue("message", content);
        }}
        id="message"
        theme="snow"
      />
      {errors.message && touched.message && (
        <ErrorText className="text-danger px-1">{errors.message}</ErrorText>
      )}
    </>
  );
};

export default NotificationForm;
